import React, { useState } from "react";

import HGraph from "components/Custom/HGraph";

import { GRAPH_TYPES } from "common/config";
import { log } from "console";

const PieChart = (props: any) => {
  const { height, data } = props;

  const pieSeries = data.pieChart.data;
  const series = [
    {
      name: "Lead Source",
      colorByPoint: true,
      data: pieSeries,
    },
  ];

  return (
    <React.Fragment>
      <div className="graphs">
        <HGraph
          width={"100%"}
          height={height}
          type={GRAPH_TYPES.PIE}
          float={"right"}
          series={series}
          title={"Lead Source"}
          exportTitle={" Pie Chart Record"}
        />
      </div>
    </React.Fragment>
  );
};

export default PieChart;
